/* Chrono Candy — Bezel-style storefront behaviour (menu, search, saved watches, gallery, tabs). */
(function () {
  var SAVED_KEY = 'chronocandy:saved-watches';

  function readSaved() {
    try {
      var list = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (w) { return w && w.handle; }) : [];
    } catch (e) { return []; }
  }
  function writeSaved(list) {
    try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isSaved(handle) {
    return readSaved().some(function (w) { return w.handle === handle; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var arrow = '<svg class="cc-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  /* ---------- Saved watches ---------- */
  function syncSaveButtons() {
    var saved = readSaved();
    var handles = saved.map(function (w) { return w.handle; });
    document.querySelectorAll('[data-cc-save]').forEach(function (btn) {
      var on = handles.indexOf(btn.dataset.handle) !== -1;
      btn.dataset.active = on ? 'true' : 'false';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var name = btn.dataset.title || 'watch';
      btn.setAttribute('aria-label', (on ? 'Unsave ' : 'Save ') + name);
      btn.title = on ? 'Unsave watch' : 'Save watch';
    });
    document.querySelectorAll('[data-cc-saved-count]').forEach(function (el) {
      el.textContent = saved.length ? saved.length : '';
      el.dataset.count = saved.length;
    });
    document.querySelectorAll('[data-cc-saved-icon]').forEach(function (el) {
      el.dataset.active = saved.length ? 'true' : 'false';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-save]');
    if (!btn) return;
    e.preventDefault();
    var list = readSaved();
    var i = list.findIndex(function (w) { return w.handle === btn.dataset.handle; });
    if (i === -1) {
      list.unshift({
        handle: btn.dataset.handle, title: btn.dataset.title, brand: btn.dataset.brand,
        price: btn.dataset.price, url: btn.dataset.url, image: btn.dataset.image
      });
    } else {
      list.splice(i, 1);
    }
    writeSaved(list);
    syncSaveButtons();
    renderSaved();
  });

  function renderSaved() {
    var box = document.querySelector('[data-cc-saved-results]');
    if (!box) return;
    var list = readSaved();
    if (!list.length) {
      box.innerHTML = '<p class="cc-search-empty">Nothing saved yet. Tap the heart on any watch to keep it here.</p>';
      return;
    }
    box.innerHTML = list.map(function (w) {
      return '<div class="cc-search-result">' +
        (w.image ? '<img src="' + esc(w.image) + '" alt="" width="58" height="70" loading="lazy">' : '') +
        '<a class="cc-search-result-text" href="' + esc(w.url) + '"><p class="cc-muted">' + esc(w.brand) + '</p><p>' + esc(w.title) + '</p></a>' +
        '<span style="font-size:12px">' + esc(w.price) + '</span>' +
        '<button type="button" class="cc-save" data-active="true" data-cc-save data-handle="' + esc(w.handle) + '" data-title="' + esc(w.title) + '" aria-label="Unsave ' + esc(w.title) + '">' +
        '<svg class="cc-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg></button>' +
        '</div>';
    }).join('');
  }

  /* ---------- Dialogs (search + saved) ---------- */
  var lastFocus = null;
  function openDialog(id) {
    var dlg = document.getElementById(id);
    var ov = document.querySelector('[data-cc-overlay]');
    if (!dlg) return;
    closeMenus();
    lastFocus = document.activeElement;
    dlg.hidden = false;
    if (ov) ov.hidden = false;
    if (id === 'cc-saved-dialog') renderSaved();
    var input = dlg.querySelector('input:not([type="hidden"])');
    (input || dlg.querySelector('button')).focus();
  }
  function closeDialogs() {
    document.querySelectorAll('.cc-dialog').forEach(function (d) { d.hidden = true; });
    var ov = document.querySelector('[data-cc-overlay]');
    if (ov) ov.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cc-open]');
    if (opener) {
      e.preventDefault();
      var topic = document.querySelector('#cc-ask-topic');
      var title = document.querySelector('[data-cc-ask-title]');
      if (opener.dataset.ccOpen === 'cc-ask-dialog') {
        if (topic) topic.value = opener.dataset.topic || 'Availability and price';
        if (title) title.textContent = opener.dataset.topic === 'A price quote' ? 'Request an offer' : 'Ask about this watch';
      }
      if (opener.dataset.ccOpen === 'cc-req-dialog') setReqMode(opener.dataset.mode);
      openDialog(opener.dataset.ccOpen);
      return;
    }
    if (e.target.closest('[data-cc-close]') || e.target.matches('[data-cc-overlay]')) closeDialogs();
  });
  // One dialog serves "Purchase request" (in stock / any) and "Want us to source one?" (sold)
  function setReqMode(mode) {
    var src = mode === 'source', offer = mode === 'offer';
    var set = function (sel, fn) { var el = document.querySelector(sel); if (el) fn(el); };
    set('[data-cc-req-title]', function (el) { el.textContent = src ? 'Want us to source one?' : offer ? 'Suggest a price' : 'Purchase request'; });
    set('[data-cc-req-intro]', function (el) { el.textContent = src ? 'This one has sold, but we can find another. Tell us what you\u2019re after and we\u2019ll search our dealer network.' : offer ? 'Name your price. It\u2019s non-binding \u2014 we\u2019ll come back with a yes or our best number.' : 'Tell us what you\u2019d pay. We\u2019ll check our stock and our dealer network and come back with options.'; });
    set('[data-cc-req-tag]', function (el) { el.value = src ? 'source-request' : offer ? 'price-suggestion' : 'purchase-request'; });
    set('[data-cc-req-type]', function (el) { el.value = src ? 'Source a watch' : offer ? 'Suggested price' : 'Purchase request'; });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDialogs(); closeMenus(); }
  });

  /* Predictive search against the real catalogue */
  var searchTimer = null;
  var searchSeq = 0;
  function runSearch(input) {
    var q = input.value.trim();
    var box = document.querySelector('[data-cc-search-results]');
    var all = document.querySelector('[data-cc-search-all]');
    if (all) all.href = '/search?type=product&q=' + encodeURIComponent(q);
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; return; }
    var seq = ++searchSeq;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== searchSeq) return;
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          box.innerHTML = '<p class="cc-search-empty">No matches. Try a reference number, or ask us to find it.</p>';
          return;
        }
        box.innerHTML = items.map(function (p) {
          var quoteTags = (window.ccQuoteTags || []);
          var tagged = (p.tags || []).some(function (t) { return quoteTags.indexOf(String(t).toLowerCase().trim()) !== -1; });
          var over = window.ccQuoteAbove > 0 && Number(p.price) > window.ccQuoteAbove;
          var price = Number(p.price) > 0 && !tagged && !over ? '$' + Number(p.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'Get a quote';
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=140';
          return '<a class="cc-search-result" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="58" height="70" loading="lazy">' : '') +
            '<div class="cc-search-result-text"><p>' + esc(p.title) + '</p></div>' +
            '<span style="font-size:12px;white-space:nowrap">' + esc(price) + '</span>' + arrow + '</a>';
        }).join('');
      })
      .catch(function () {});
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cc-search-input]')) return;
    clearTimeout(searchTimer);
    var input = e.target;
    searchTimer = setTimeout(function () { runSearch(input); }, 180);
  });

  /* ---------- Browse menu ---------- */
  function closeMenus(except) {
    document.querySelectorAll('[data-cc-menu-toggle]').forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-cc-menu]').forEach(function (m) {
      if (except && m.id === except.getAttribute('aria-controls')) return;
      m.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cc-menu-toggle]');
    if (t) {
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      var open = t.getAttribute('aria-expanded') !== 'true';
      closeMenus();
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) {
        panel.dataset.align = t.dataset.align || 'start';
        panel.hidden = !open;
        if (open && t.dataset.align !== 'end') {
          var card = panel.querySelector('.cc-menu-card');
          var wrap = panel.getBoundingClientRect();
          var r = t.getBoundingClientRect();
          if (card && card.querySelector('.cc-mega')) {
            card.style.marginLeft = '';
          } else if (card) {
            var inner = card.parentElement.getBoundingClientRect();
            var room = inner.width - card.offsetWidth;
            card.style.marginLeft = Math.max(0, Math.min(r.left - inner.left - 8, room)) + 'px';
          }
        } else if (panel.querySelector('.cc-menu-card')) {
          panel.querySelector('.cc-menu-card').style.marginLeft = '';
        }
      }
      return;
    }
    if (!e.target.closest('.cc-menu-card')) closeMenus();
  });

  /* ---------- Collection filters: one popover open at a time ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-cc-filter][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cc-filter]') || !e.target.open) return;
    document.querySelectorAll('[data-cc-filter][open]').forEach(function (d) { if (d !== e.target) d.removeAttribute('open'); });
  }, true);
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-cc-filters]')) return;
    // Drop empty price inputs; send dollars as Shopify expects (price filters take whole currency units)
    e.target.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  });

  /* ---------- Header "Chat" link opens Gorgias; floating bubble hidden ---------- */
  if (document.querySelector('[data-cc-chat]')) document.documentElement.classList.add('cc-chat-inline');
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cc-chat]')) return;
    e.preventDefault();
    var g = window.GorgiasChat;
    if (g && typeof g.open === 'function') { g.open(); return; }
    if (g && typeof g.init === 'function') { g.init().then(function () { window.GorgiasChat.open(); }); return; }
    window.location.href = 'sms:3103630481';
  });

  /* ---------- Collection sidebar: brand search + mobile drawer ---------- */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cc-brand-search]')) return;
    var q = e.target.value.trim().toLowerCase();
    var box = e.target.closest('.cc-side-group').querySelector('[data-cc-brand-chips]');
    box.querySelectorAll('a').forEach(function (a) { a.hidden = q && a.textContent.toLowerCase().indexOf(q) === -1; });
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cc-side-toggle]');
    if (!t) return;
    var root = document.querySelector('[data-cc-coll]');
    if (root) root.classList.toggle('is-open');
  });

  /* ---------- Home tabs (brand filter) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cc-tab]');
    if (!tab) return;
    var root = tab.closest('[data-cc-tabs]');
    root.querySelectorAll('[data-cc-tab]').forEach(function (b) {
      var on = b === tab;
      b.dataset.active = on ? 'true' : 'false';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cc-panel]').forEach(function (p) {
      p.hidden = p.dataset.ccPanel !== tab.dataset.ccTab;
    });
    var link = root.querySelector('[data-cc-view-all]');
    if (link && tab.dataset.url) link.href = tab.dataset.url;
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-cc-thumb]');
    if (!th) return;
    var gallery = th.closest('[data-cc-gallery]');
    var main = gallery.querySelector('[data-cc-main-img]');
    main.src = th.dataset.src;
    main.srcset = th.dataset.srcset || '';
    main.alt = th.dataset.alt || main.alt;
    gallery.querySelectorAll('[data-cc-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === th ? 'true' : 'false');
    });
  });

  /* ---------- Long descriptions ---------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-cc-more]');
    if (!more) return;
    var target = document.getElementById(more.getAttribute('aria-controls'));
    var open = target.classList.toggle('is-clamped') === false;
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    more.firstChild.textContent = open ? 'Show less ' : 'Read more ';
  });
  function clampDescriptions() {
    document.querySelectorAll('[data-cc-clamp]').forEach(function (el) {
      var btn = document.querySelector('[aria-controls="' + el.id + '"]');
      if (el.scrollHeight > 420) { el.classList.add('is-clamped'); if (btn) btn.hidden = false; }
    });
  }

  /* ---------- Sort select on collection pages ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cc-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Review carousel progress bar ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-cc-carousel]').forEach(function (track) {
      var bar = track.parentElement.querySelector('[data-cc-carousel-bar]');
      if (!bar || track.dataset.ccBound) return;
      track.dataset.ccBound = '1';
      function update() {
        var ratio = track.clientWidth / track.scrollWidth;
        var max = track.scrollWidth - track.clientWidth;
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.parentElement.style.display = ratio >= 0.999 ? 'none' : '';
        bar.style.width = (ratio * 100) + '%';
        bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Gentle reveal on scroll ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.cc-section-heading, .cc-card, .cc-review, .cc-journal-card, .cc-info-card, .cc-step, .cc-feature-body, .cc-story-inner');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t, i) {
      if (t.dataset.ccReveal) return;
      t.dataset.ccReveal = '1';
      var r = t.getBoundingClientRect();
      if (r.top < window.innerHeight) return; // already on screen: leave as is
      t.classList.add('cc-reveal');
      t.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(t);
    });
  }

  // "Sell yours" links carry ?brand=&ref= into the sell form
  function prefillFromUrl() {
    var q = new URLSearchParams(location.search);
    var brand = q.get('brand'), ref = q.get('ref');
    if (!brand && !ref) return;
    document.querySelectorAll('.cc-source-form form').forEach(function (f) {
      var b = f.querySelector('select[name="contact[brand]"]');
      if (b && brand) {
        var opt = Array.prototype.find.call(b.options, function (o) { return o.text.toLowerCase() === brand.toLowerCase(); });
        if (opt) b.value = opt.value; else { b.value = 'Another brand'; ref = brand + ' ' + (ref || ''); }
      }
      var r = f.querySelector('input[name="contact[reference]"]');
      if (r && ref && !r.value) r.value = ref.trim();
    });
  }
  // Factory renders (white backdrop) float on the card like Bezel's; real photos keep filling it
  function markRenders() {
    document.querySelectorAll('.cc-card-photo--cover img[data-cc-card-img]').forEach(function (img) {
      if (img.dataset.ccChecked) return;
      var check = function () {
        img.dataset.ccChecked = '1';
        try {
          var c = document.createElement('canvas'); c.width = c.height = 24;
          var x = c.getContext('2d'); x.drawImage(img, 0, 0, 24, 24);
          var d = x.getImageData(0, 0, 24, 24).data, white = 0, pts = [[1,1],[22,1],[1,22],[22,22],[12,1],[1,12],[22,12],[12,22]];
          pts.forEach(function (p) { var i = (p[1] * 24 + p[0]) * 4; if (d[i] > 236 && d[i+1] > 236 && d[i+2] > 236) white++; });
          if (white >= 7) { var box = img.closest('.cc-card-photo'); box.classList.remove('cc-card-photo--cover'); box.classList.add('cc-card-photo--contain'); }
        } catch (e) {}
      };
      if (img.complete && img.naturalWidth) check(); else img.addEventListener('load', check, { once: true });
    });
  }
  // Filter lists: show 5, then "See more" (Amazon-style)
  function initMoreLists() {
    document.querySelectorAll('[data-cc-more-list]').forEach(function (list) {
      if (list.dataset.ccMoreReady) return; list.dataset.ccMoreReady = '1';
      var items = list.querySelectorAll(':scope > span'); if (items.length <= 6) return;
      var hasOn = false;
      items.forEach(function (it, i) { if (i >= 5 && !it.classList.contains('is-on')) it.hidden = true; if (it.classList.contains('is-on')) hasOn = true; });
      var b = document.createElement('button'); b.type = 'button'; b.className = 'cc-more-toggle';
      b.textContent = 'See ' + (items.length - 5) + ' more';
      b.addEventListener('click', function () {
        var open = b.dataset.open === '1';
        items.forEach(function (it, i) { if (i >= 5 && !it.classList.contains('is-on')) it.hidden = open; });
        b.dataset.open = open ? '0' : '1'; b.textContent = open ? 'See ' + (items.length - 5) + ' more' : 'See less';
      });
      list.after(b);
    });
  }
  // Mega menu: hovering (desktop) or first tap (touch) on a brand shows that brand's models
  function showBrand(key) {
    document.querySelectorAll('[data-cc-mega-brand]').forEach(function (a) { a.classList.toggle('is-active', a.dataset.ccMegaBrand === key); });
    document.querySelectorAll('[data-cc-mega-panel]').forEach(function (p) { p.classList.toggle('is-active', p.dataset.ccMegaPanel === key); });
  }
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('[data-cc-mega-brand]');
    if (a && window.matchMedia('(hover: hover)').matches && window.innerWidth > 900) showBrand(a.dataset.ccMegaBrand);
  });
  document.addEventListener('focusin', function (e) {
    var a = e.target.closest && e.target.closest('[data-cc-mega-brand]');
    if (a) showBrand(a.dataset.ccMegaBrand);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cc-mega-brand]');
    if (!a || (window.matchMedia('(hover: hover)').matches && window.innerWidth > 900)) return;
    if (!a.classList.contains('is-active')) { e.preventDefault(); showBrand(a.dataset.ccMegaBrand); }
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cc-tip]'); if (!b) return;
    var tip = b.closest('.cc-market').querySelector('.cc-market-tip'); tip.hidden = !tip.hidden;
  });
  // Copy-link buttons; close the More menu when clicking elsewhere
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-cc-copy]');
    if (c) { try { navigator.clipboard.writeText(c.dataset.ccCopy); c.textContent = 'Copied'; setTimeout(function () { c.textContent = 'Copy'; }, 1500); } catch (er) {} }
    document.querySelectorAll('details[data-cc-more][open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  function init() {
    initReveal();
    initCarousels();
    syncSaveButtons();
    clampDescriptions();
    // Reopen the question popup after the form posts back (success or error)
    if (document.querySelector('[data-cc-ask-autoopen]')) openDialog('cc-ask-dialog');
    if (document.querySelector('[data-cc-req-autoopen]')) openDialog('cc-req-dialog');
    prefillFromUrl();
    markRenders();
    initMoreLists();
  }
  // Cards added later (load more, carousels, search) get the render check too
  if (window.MutationObserver) new MutationObserver(function () { markRenders(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

// Collection header: intro "read more" and brand/model rail arrows
(function () {
  document.addEventListener('click', function (e) {
    var m = e.target.closest('[data-cc-intro-more]'); if (!m) return;
    var w = m.closest('[data-cc-intro]'); var open = w.classList.toggle('is-open');
    m.textContent = open ? 'read less' : 'read more'; m.setAttribute('aria-expanded', open);
  });
  document.querySelectorAll('[data-cc-rail]').forEach(function (rail) {
    var t = rail.querySelector('[data-cc-rail-track]'), prev = rail.querySelector('[data-cc-rail-prev]'), next = rail.querySelector('[data-cc-rail-next]');
    function sync() { prev.hidden = t.scrollLeft < 8; next.hidden = t.scrollLeft + t.clientWidth >= t.scrollWidth - 8; }
    prev.addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth * 0.8 }); });
    next.addEventListener('click', function () { t.scrollBy({ left: t.clientWidth * 0.8 }); });
    t.addEventListener('scroll', sync, { passive: true }); window.addEventListener('resize', sync); sync();
    var cur = t.querySelector('.is-current'); if (cur) t.scrollLeft = cur.offsetLeft - 40;
  });
})();
